import { render, staticRenderFns } from "./TimeBadge.vue?vue&type=template&id=002370de&scoped=true&"
import script from "./TimeBadge.vue?vue&type=script&lang=js&"
export * from "./TimeBadge.vue?vue&type=script&lang=js&"
import style0 from "./TimeBadge.vue?vue&type=style&index=0&id=002370de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002370de",
  null
  
)

export default component.exports